import { localStorageKey } from '../../../../common/utils/constant';
import { filterFieldsOfCollection } from '../../../common/FieldTypes';

export const processData = (data, rowObj) => {
  const bodyData = data.map((row) => {
    if (row.id === rowObj.id) {
      row.key = rowObj.key;
      row.value = rowObj.value;
    }
    return row;
  });

  if (data[data.length - 1].id === rowObj.id) {
    let newId = rowObj.id + 1;
    let newRow = {
      id: newId,
      key: '',
      valueFrom: 'event',
      value: '',
      fieldType: '',
      isMultiSelect: false,
    };
    bodyData.push(newRow);
  }
  return bodyData;
};

export const getFilteredArray = (array) => {
  let filterArr = [];
  for (let i = 0; i < array.length; i++) {
    if (array[i].key && array[i].key != '') {
      filterArr.push(array[i]);
    }
  }
  return filterArr;
};

export const getFieldInfoByName = (name) => {
  let description = '';
  switch (name) {
    case 'collection':
      description = 'Select a collection which you want to update.';
      break;
    case 'updateFindBy':
      description = 'Choose any one option to identify the location of Collection item.';
      break;
    case 'updateFindByResponseKeyForValue':
    case 'storageCustomKey':
      description = 'Enter the JSON path of the Item Id Key';
      break;
    case 'successMessage':
      description = '(Optional) Enter custom success message.';
      break;
    case 'errorMessage':
      description = '(Optional) Enter custom error message.';
      break;
    case 'page':
      description = 'Select the page you want users to land on.';
      break;
    case 'updateEntityBy':
      description = 'Choose any one option to switch Collection (Browser Storage) item.';
      break;
    case 'userRefField':
      description = 'Choose User Field to add Parent Collection Item';
      break;
    case 'collectionRefFields':
      description = 'Choose Reference Field to add Parent Collection Item';
      break;
    case 'userRole':
      description = 'Choose User Role for User to created with';
      break;
    case 'dataLocation':
      description = 'Select where the data should come from for the conditional redirect.';
      break;
    case 'collectionPage':
      description = 'Select the Page or Snippet that is connected to a collection.';
      break;
    case 'dataLocationCollection':
      description = `Select the Collection associated with the data location you've chosen; this collection will be used to set up the rules for redirection.`;
      break;
    case 'collectionField':
      description =
        'Select the specific field from your collection that will determine the rules for redirection based on its values.';
      break;
    case 'sessionFieldName':
      description = `Enter the Field Name (also known as JSON key) that you want to use from the Browser Session. You'll use the value of this field to set up the rules for conditional redirection.`;
      break;
    case 'redirectUrl':
      description = 'Choose the page where you want users to go after they log in.';
      break;
    case 'enableLoginUser':
      description = 'Enable to Login with recently created user.';
      break;
    case 'modalDataLocation':
      description =
        'Select where you want to gather the data for defining the rules that control when a pop-up window or modal appears. This data can come from a collection or from your current browser session.';
      break;
    case 'modalDataLocationCollection':
      description = `Pick the collection that's connected to the data location you've selected. This collection will be used to set the rules for when the modal window should open.`;
      break;
    case 'modalCollectionField':
      description =
        'Select the specific field from your collection that will determine when the modal should open based on its values.';
      break;
    case 'modalSessionFieldName':
      description = `Enter the Field Name (also known as JSON key) that exists in the Browser Session. You can use the value of this field to set up the rules for when the modal should open conditionally.`;
      break;
    case 'modalCollectionPage':
      description = 'Select the Page or Snippet that is connected to a collection.';
      break;
    case 'confirmationMessage':
      description = '(Optional) A custom confirmation alert message to display on a popup.';
      break;
    case 'externalAPI':
      description = `Select a External API that previously you've created.`;
      break;
    case 'floatingModalId':
      description =
        'Choose a floating modal (from Snippets) that you want to display using this event.';
      break;
    case 'createTenant':
      description = 'Create Tenant along with User.';
      break;
    case 'createSubTenant':
      description = 'Create Sub Tenant along with User.(Requires ‘Create Tenant’ to be enabled.)';
      break;
    case 'createUserSetting':
      description = 'Create User Setting along with User.(Requires ‘Create Tenant’ to be enabled.)';
      break;
    case 'displayField':
      description = `Select the field to use as the item's display name(Ex:Copy of the 'Jhon' field).`;
      break;
    case 'excludeFields':
      description = `Select the fields that you don't want to be cloned.`;
      break;
    default:
      break;
  }
  return description;
};

export const createActionSettingsSchema = (actionData, eventAction) => {
  let schema = {};
  actionData.args.forEach((args) => {
    const dbParameters = eventAction.parameters.find((param) => {
      return param.name === args.name;
    });
    if (dbParameters) {
      schema[args.name] = dbParameters ? dbParameters.value : '';
    } else {
      schema[args.name] = args.value || '';
    }
  });
  return schema;
};

export const extractParameters = (values, actionData) => {
  return Object.keys(values).map((value) => {
    const action = actionData.args.find((param) => param.name === value);
    return { name: value, value: values[value], type: action.type };
  });
};

export const validateFormDataSessionKey = (value) => {
  console.log('🚀 ~ validateFormDataSessionKey ~ value:', value);
  let error;
  if (!value) {
    error = "Form Data Session Key can't be blank";
  } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
    error = 'Form Data Session Key should not contain special characters';
  } else if (value.length > 50) {
    error = 'Form Data Session Key can not be more than 50 characters';
  }
  return error;
};

export const validateResponseDataSessionKey = (value) => {
  console.log('🚀 ~ validateResponseDataSessionKey ~ value:', value);
  let error;
  if (!value) {
    error = "Response Data Session Key can't be blank";
  } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
    error = 'Response Data Session Key should not contain special characters';
  } else if (value.length > 50) {
    error = 'Response Data Session Key can not be more than 50 characters';
  }
  return error;
};

export const validateItemIdBSLKey = (value) => {
  let error;
  if (!value) {
    error = "Item ID Key can't be blank";
  } else if (!/^[A-Za-z_.0-9\[\]]+$/i.test(value)) {
    error = 'Item ID Key should not contain special characters';
  }
  return error;
};

// For Collection With Reference Field Events

export const collectionOptions = (events) => {
  let options = [{ value: '', label: 'Choose Collection' }];
  let collections = events ? events.collections : [];
  if (collections.length > 0) {
    options = options.concat(
      collections.map((collection) => {
        return { value: collection.collectionName, label: collection.collectionTitle };
      }),
    );
  }
  return options;
};

export const userFieldsOptions = (events) => {
  let options = [{ value: '', label: 'Choose Field' }];
  let collections = events ? events.collections : [];
  if (collections.length > 0) {
    const userCollection = collections.find((coll) => coll.collectionName === 'user');
    if (userCollection && userCollection.fields) {
      const userFields = filterFieldsOfCollection(userCollection);
      options = options.concat(
        userFields.map((field) => {
          return { value: field.fieldName, label: field.fieldTitle.en };
        }),
      );
    }
  }
  return options;
};

export const userRolesOptions = (events, userRoles) => {
  let options = [{ value: '', label: 'Choose User Role' }];
  let collections = events ? events.collections : [];
  if (collections.length > 0) {
    options = options.concat(
      userRoles.map((item) => {
        return { value: item.name, label: item.name };
      }),
    );
  }
  return options;
};

export const getPageOption = (events) => {
  let options = [];
  const { pages } = events || '';
  const pageOptions =
    pages && pages.length > 0
      ? pages.map((item, key) => {
          return { value: '/' + item.slug, label: item.name };
        })
      : [];
  return [...options, ...pageOptions];
};

export const getCurrentEnvironment = () => {
  return localStorage.getItem(localStorageKey.ENVIRONMENT) || 'PRODUCTION';
};

export const hasEnvironmentKey = (arr = []) =>
  arr.some((rule) => Object.prototype.hasOwnProperty.call(rule, 'environment'));
